import {UserComAttribute, UserComEventNames, userComUpdateUserAttributes} from "@pg-mono/user-com";

interface ITrackLeadUserComAttributesParams {
    name: string | null;
    phone: string | null;
}

export const trackLeadUserComAttributes = ({name, phone}: ITrackLeadUserComAttributesParams) => {
    userComUpdateUserAttributes({
        event_name: UserComEventNames.UserLead,
        ...(name ? {[UserComAttribute.NAME]: name} : {}),
        ...(phone ? {[UserComAttribute.PHONE_NUMBER]: phone} : {})
    });
};
import {UserComAttribute, UserComEventNames, userComUpdateUserAttributes} from "@pg-mono/user-com";

interface ITrackLeadUserComAttributesParams {
    name: string | null;
    phone: string | null;
}

export const trackLeadUserComAttributes = ({name, phone}: ITrackLeadUserComAttributesParams) => {
    userComUpdateUserAttributes({
        event_name: UserComEventNames.UserLead,
        ...(name ? {[UserComAttribute.NAME]: name} : {}),
        ...(phone ? {[UserComAttribute.PHONE_NUMBER]: phone} : {})
    });
};
